import { render, staticRenderFns } from "./CompanyJobRequest.vue?vue&type=template&id=727e318c&scoped=true&"
import script from "../../../services/company/job_request/company-job-request.js?vue&type=script&lang=js&"
export * from "../../../services/company/job_request/company-job-request.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/job_request.css?vue&type=style&index=0&id=727e318c&scoped=true&lang=css&"
import style1 from "@/assets/css/job_category.css?vue&type=style&index=1&id=727e318c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727e318c",
  null
  
)

export default component.exports